/*
 * Copyright (c) Fing Ltd. All rights reserved.
 */

import React, {Component} from 'react';

import {Redirect, withRouter} from "react-router-dom";
import { UserContext } from "../UserContext";
import {intervalIdFromParams, productIdFromParams, promoCodeFromParams} from "../helpers/BillingHelper";

class SubscribeRedirectToDashboard extends Component {

    static contextType = UserContext;

    render() {
        return <Redirect to="/account/dashboard" />;
    }


}

export default withRouter(SubscribeRedirectToDashboard)